<div [formGroup]="formGroup" class="no-field-space">

  <sc-title>
    {{"Detach semi trailer truck"
    | translate : ["tmc.transport-attach-detach.dialog.step.title.detach-trailer-semi-trailer-truck",
    translationService.language]
    }}
  </sc-title>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <mat-radio-group formControlName="transportScope">
    <div>
      <mat-radio-button class="option" [value]="TransportScope.TRAILER">
        {{ 'Trailer' | translate: ['tmc-yard.entity.transport.transport-scope.' + TransportScope.TRAILER,
        translationService.language] }}
      </mat-radio-button>
    </div>
    <div>
      <mat-radio-button class="option" [value]="TransportScope.SWAP_TRAILER">
        {{ 'Swap Trailer' | translate: ['tmc-yard.entity.transport.transport-scope.' + TransportScope.SWAP_TRAILER,
        translationService.language] }}
      </mat-radio-button>
    </div>
  </mat-radio-group>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <sc-flex>
    <sc-string-field [label]="'cargo'| translate: ['tmc-yard.entity.transport.cargo', translationService.language]"
      formControlName="cargo" [grow]="true"></sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field
      [label]="'orderReference'| translate: ['tmc-yard.entity.transport.reference', translationService.language]"
      formControlName="orderReference" [grow]="true"></sc-string-field>
  </sc-flex>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <sc-flex *ngIf="this.stepperModel.workingData.targetTransportScope === TransportScope.TRAILER">
    <sc-string-field
      [label]="'trailer number plated'| translate: ['tmc.transport-attach-detach.dialog.label.trailerNumberPlate', translationService.language]"
      formControlName="trailerNumberPlate" [grow]="true"></sc-string-field>
    <sc-content-spacer></sc-content-spacer>
    <sc-string-field
      [label]="'trailer identifier'| translate: ['tmc.transport-attach-detach.dialog.label.trailerIdentifier', translationService.language]"
      formControlName="trailerIdentifier" [grow]="true"></sc-string-field>
  </sc-flex>

  <sc-flex *ngIf="this.stepperModel.workingData.targetTransportScope === TransportScope.SWAP_TRAILER">
    <sc-string-field
      [label]="'swap trailer number'| translate: ['tmc.transport-attach-detach.dialog.label.swapTrailerNumber', translationService.language]"
      formControlName="swapTrailerNumber" [grow]="true"></sc-string-field>
  </sc-flex>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <app-structure-selection-field (selectionChanged)="onStationSelectionChanged($event)"></app-structure-selection-field>
  
</div>